import { IGetFilePreviewBody } from "./features/document-viewer/interfaces/IGetFilePreviewBody";

export const apiConfig = {
    getFilePreview: (_params: IGetFilePreviewBody): string => {
        throw new Error("You haven't set the getFilePreview endpoint");
    },

    sendFileChunk: (): string => {
        throw new Error("You haven't set the sendFileChunk endpoint");
    },

    cancelFileUpload: (): string => {
        throw new Error("You haven't set the cancelFileUpload endpoint");
    },

    getUploadedBytes: (_params: { ticketId: string }): string => {
        throw new Error("You haven't set the getUploadedBytes endpoint");
    },

    commitFileUpload: (): string => {
        throw new Error("You haven't set the commitFileUpload endpoint");
    }
};
